import { createAction } from 'redux-actions';
import MessageTypes from './interfaces';

export const messagesRequest = createAction(MessageTypes.MESSAGES_REQUEST);
export const messagesOpen = createAction(MessageTypes.MESSAGES_OPEN);
export const messageClose = createAction(MessageTypes.MESSAGES_CLOSE);
